import React from 'react'
import { ReactComponent as LsOn } from '../../icons/ls_on.svg'
import { ReactComponent as LsOff } from '../../icons/ls_off.svg'

import { Scrollbars } from 'react-custom-scrollbars'

import styled from 'styled-components'
import points from '../../data/points_data'

const Element = styled.div`
  padding: 0;
  z-index: 2000;
  float: left;
  padding: 0.6rem 0;
  cursor: pointer;
  width: calc(50% - 2rem);
  min-width: 150px;
  overflow: visible;
`

const LsOnIcon = styled(LsOn)`
  float: left;
  margin: 8px 8px 0 0;
`
const LsOffIcon = styled(LsOff)`
  float: left;
  margin: 8px 8px 0 0;
`
const LSDesc = styled.div`
  float: left;
  font-style: normal;
`

const Name = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  width: 120px;
  overflow: visible;
`

const Country = styled.p`
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  color: #a4a4a4;
`
const ViewAllDiv = styled.div`
  margin-bottom: 1rem;
  padding: 0.5rem 0;
  clear: both;
`

const ViewAll = styled.a`
  padding: 0.5rem 1rem;
  margin: 0 0 1rem 0;
  border: 1px solid #444;
  border-radius: 0.5rem;
  line-height: 2rem;
`

const CardCable = ({ cable, mobile, urlTo, h, w, detail, toggle }) => {
  //Data filter
  const lsName = d => {
    const list = points.filter(obj => obj.id === d)
    const item = list[0]
    return item
  }

  let lslist = []
  for (let i = 0; i < cable.ls.length; i++) {
    lslist.push(lsName(cable.ls[i]))
  }
  lslist = lslist.sort((a, b) => (a.name > b.name ? 1 : -1))
  lslist = lslist.filter(obj => obj.ls === 1)

  // Element
  const ls = lslist.map((d, i) => {
    return (
      <Element
        key={'card-cable-li-' + i}
        onClick={e => {
          urlTo('', 'location', d.name)
        }}>
        {d.ls_telxius ? <LsOnIcon /> : <LsOffIcon />}
        <LSDesc>
          <Name>{d.name}</Name>
          <Country>{d.country}</Country>
        </LSDesc>
      </Element>
    )
  })

  // Element

  const ContentCable = ({ mobile, h, w, ls, detail, toggle, n }) => {
    return mobile ? (
      detail ? (
        w < 370 ? (
          <div style={{ width: w, height: h - 220 }}>{ls}</div>
        ) : (
          <div> {ls}</div>
        )
      ) : (
        <ViewAllDiv>
          <ViewAll onClick={() => toggle()}> view {n} landing station</ViewAll>
        </ViewAllDiv>
      )
    ) : (
      <Scrollbars
        style={{
          width: '210px',
          height: 'calc(100vh - 200px)',
        }}
        renderTrackVertical={props => <div {...props} className="track-vertical" />}
        renderThumbVertical={props => <div {...props} className="thumb-vertical" />}>
        {ls}
      </Scrollbars>
    )
  }

  return <ContentCable mobile={mobile} ls={ls} h={h} w={w} detail={detail} toggle={toggle} n={lslist.length} />
}

export default CardCable
